import { inject, Injectable, signal } from '@angular/core';
import {
    SelectedResearchTopic,
    TopicType,
} from '../../../shared/interfaces/selected-research-topic.model';
import { ProfileService } from '../../../profile/profile.service';
import { ResearchTopic } from '../../../shared/interfaces/research-topic.intreface';
import { ResearchPerson } from '../../../shared/interfaces/research-person.model';
import { ResearchPersonData } from '../../../shared/interfaces/research-person-data.model';
import { DepositKeywordsMode } from './deposit-keywords.component';

@Injectable({ providedIn: 'root' })
export class DepositKeywordsSuggestionsService {
    private profileService = inject(ProfileService);

    MAX_SUGGESTIONS = 10;
    recentKeywords: SelectedResearchTopic[];
    profileKeywords: SelectedResearchTopic[];
    recentTopics: SelectedResearchTopic[];
    profileTopics: SelectedResearchTopic[];
    readonly suggestions = signal<SelectedResearchTopic[]>(null);

    clearSuggestions() {
        this.suggestions.set(null);
    }

    transformKeywordsToSelectedTopics(data: string[]): SelectedResearchTopic[] {
        if (data == null) {
            return [];
        }
        const selTopics: SelectedResearchTopic[] =
            new Array<SelectedResearchTopic>();
        for (let i = 0; i < data.length; i++) {
            selTopics.push(
                new SelectedResearchTopic('', data[i], '', TopicType.KEYWORD),
            );
        }
        return selTopics;
    }

    transformTopicsToSelectedTopics(data: any[]): SelectedResearchTopic[] {
        if (!data) {
            return [];
        }
        const selTopics: SelectedResearchTopic[] =
            new Array<SelectedResearchTopic>();
        data.forEach(function (value) {
            selTopics.push(
                SelectedResearchTopic.buildFromResearchTopic(
                    value as ResearchTopic,
                ),
            );
        });
        return selTopics;
    }

    buildSuggestions(): SelectedResearchTopic[] {
        return [].concat(
            this.profileTopics,
            this.profileKeywords,
            this.recentTopics,
            this.recentKeywords,
        );
    }

    retrieveSuggestions() {
        const profile: ResearchPerson = this.profileService.getProfileData();
        if (profile) {
            const resData: ResearchPersonData = profile.getData();
            this.recentKeywords = this.transformKeywordsToSelectedTopics(
                resData.recentKeywords,
            );
            this.recentTopics = this.transformTopicsToSelectedTopics(
                resData.recentTopics,
            );
            this.profileKeywords = this.transformKeywordsToSelectedTopics(
                resData.profileKeywords,
            );
            this.profileTopics = this.transformTopicsToSelectedTopics(
                resData.profileTopics,
            );

            this.suggestions.set(this.buildSuggestions());
        }
    }

    getSuggestions(
        contains?: string,
        mode: DepositKeywordsMode = 'keywordsAndSubjects',
    ): SelectedResearchTopic[] {
        if (!this.suggestions()) {
            this.retrieveSuggestions();
        }
        if (this.suggestions()) {
            const filteredSuggestions = this.suggestions()
                .filter((suggestion) => {
                    if (mode === 'onlyKeywords') {
                        return suggestion.type === TopicType.KEYWORD;
                    } else if (mode === 'onlySubjects') {
                        return suggestion.type === TopicType.SUBJECT;
                    } else {
                        return true;
                    }
                })
                .filter((suggestion) => {
                    if (!contains) {
                        return true;
                    }
                    return suggestion.description
                        .toLowerCase()
                        .includes(contains.toLowerCase());
                });
            return filteredSuggestions.slice(0, this.MAX_SUGGESTIONS);
        }
        return [];
    }
}
